import React from 'react';
// import { Link } from 'react-router-dom';

function StructureInformationEducation() {
  return (
    <section className='structureInformationEducation'>
      <p className='structureInformationEducation__text'>
        Учреждение возглавляет начальник МКУ «АСС Северодвинска» (далее –
        Руководитель), назначаемый на должность и освобождаемый от должности
        Учредителем в соответствии с правовыми актами МО «Северодвинск».
      </p>
      <p className='structureInformationEducation__text'>
        Руководство Курсами гражданской обороны – структурным подразделением,
        осуществляющим образовательную деятельность, осуществляет начальник
        городских курсов гражданской обороны.
      </p>
    </section>
  );
}

export default StructureInformationEducation;
